import React, { useState, ReactElement } from "react";

import { resetPassword } from "../../apis/firebase";

import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";

// Components
import AuthPageLayout from "../../components/layout/auth/authPage.layout";
import MultiLanguage from "../../components/global/multiLanguage/multiLanguage";

const ForgotPassword = (): ReactElement => {
  const [loginError, setLoginError] = useState("");
  const [loginMessage, setLoginMessage] = useState("");
  const [successfullSubmit, setSuccessfullSubmit] = useState(false);

  const { t } = useTranslation();

  const initialValues = {
    email: "",
    password: "",
  };
  const FormSchema = Yup.object().shape({
    email: Yup.string()
      .email(t("FORM_EMAIL_VALIDATION_FORMAT"))
      .required(t("FORM_REQUIRED_FIELD")),
  });
  const formik = useFormik({
    initialValues,
    validationSchema: FormSchema,
    onSubmit: async (values) => {
      try {
        await resetPassword(values.email);
        setLoginMessage("Please check your email for password recovery");
        setSuccessfullSubmit(true);
      } catch (e) {
        setLoginError(`Something went wrong please try again! ${e.message}`);

        console.log(e);
      }
    },
  });

  return (
    <>
      {!successfullSubmit && (
        <div className="d-flex flex-column mb-4">
          <div className="mb-3">
            <div className="d-flex align-items-start justify-content-between">
              <h1 className="mb-2">{t("FORGOT_PASSWORD_TITLE")}</h1>
            </div>
            <p className="m-0">{t("FORGOT_PASSWORD_DESCRIPTION")}</p>
          </div>
          <form onSubmit={formik.handleSubmit}>
            <span className="message">{loginMessage}</span>

            <>
              <span className="danger">{loginError}</span>
              <div className="mb-3">
                <div className="mb-3">
                  <input
                    type="email"
                    name="email"
                    className={`form-control ${
                      formik.errors.email ? "is-invalid" : ""
                    }`}
                    placeholder={t("FORM_EMAIL_PLACEHOLDER")}
                    {...formik.getFieldProps("email")}
                  />
                  {formik.touched.email && formik.errors.email ? (
                    <div className="invalid-feedback error-block">
                      {formik.errors.email}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="mt-2">
                <button type="submit" className="btn btn-primary fw-bold w-100">
                  {t("FORM_BUTTON_SUBMIT_LABEL")}
                </button>
              </div>
              <div className="mt-4">
                <Link to="/login" className="btn btn-secondary fw-bold w-100">
                  {t("FORM_BUTTON_LOGIN_LABEL")}
                </Link>
              </div>
            </>
          </form>
        </div>
      )}
      {successfullSubmit && (
        <div className="d-flex flex-column mb-4">
          <div className="mb-3">
            <h1 className="mb-2">{t("FORGOT_PASSWORD_LINK_SENT_TITLE")}</h1>
            <div
              dangerouslySetInnerHTML={{
                __html: t("FORGOT_PASSWORD_LINK_SENT_DESCRIPTION"),
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ForgotPassword;
